import $ from 'jquery';
import Swal from 'sweetalert2';
import Chart from 'chart.js/auto';
import { initTableUtils } from '../utils/table-utils';

export function initPerformanceMonitoring() {
    const pageIdElem = document.getElementById('page-id');
    if (!pageIdElem || pageIdElem.dataset.page !== 'performance') return;

    const urlData = window.PerformanceConfig.urlData;
    const urlBenchmark = window.PerformanceConfig.urlBenchmark;
    const urlClear = window.PerformanceConfig.urlClear;

    let historicalChart = null;
    const chartCanvas = document.getElementById('historicalChart');
    if (!chartCanvas) return;
    const ctx = chartCanvas.getContext('2d');

    function initChart(labels, totalData, queryData, bootstrapData) {
        if (historicalChart) {
            historicalChart.destroy();
        }

        historicalChart = new Chart(ctx, {
            type: 'line',
            data: {
                labels: labels,
                datasets: [
                    {
                        label: 'Total Respon (ms)',
                        data: totalData,
                        borderColor: '#28a745',
                        backgroundColor: 'rgba(40, 167, 69, 0.05)',
                        borderWidth: 2,
                        tension: 0.3,
                        fill: true
                    },
                    {
                        label: 'MySQL Query (ms)',
                        data: queryData,
                        borderColor: '#17a2b8',
                        backgroundColor: 'rgba(23, 162, 184, 0.05)',
                        borderWidth: 2,
                        tension: 0.3,
                        fill: true
                    },
                    {
                        label: 'Bootstrap Time (ms)',
                        data: bootstrapData,
                        borderColor: '#007bff',
                        backgroundColor: 'rgba(0, 123, 255, 0.05)',
                        borderWidth: 2,
                        tension: 0.3,
                        fill: true
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: 'top',
                        labels: { boxWidth: 12, font: { size: 11, weight: 'bold' } }
                    }
                },
                scales: {
                    x: { grid: { display: false } },
                    y: {
                        min: 0,
                        ticks: { callback: function (value) { return value + ' ms'; } }
                    }
                }
            }
        });
    }

    function loadPerformanceData() {
        $.ajax({
            url: urlData,
            type: 'GET',
            dataType: 'json',
            success: function (res) {
                if (res.status === 'success') {
                    const data = res.data;
                    const stats = data.stats;

                    $('#totalRequests').text(stats.total_requests.toLocaleString('id-ID'));
                    $('#avgBootstrap').text(stats.avg_bootstrap.toFixed(1) + ' ms');
                    $('#avgQuery').text(stats.avg_query.toFixed(1) + ' ms');
                    $('#avgTotal').text(stats.avg_total.toFixed(1) + ' ms');
                    $('#avgQueriesCount').text(stats.avg_queries_count.toFixed(1));
                    $('#avgMemory').text(stats.avg_memory.toFixed(1) + ' MB');

                    const percentBootstrap = Math.min((stats.avg_bootstrap / 300) * 100, 100);
                    const percentQuery = Math.min((stats.avg_query / 200) * 100, 100);
                    const percentTotal = Math.min((stats.avg_total / 500) * 100, 100);

                    $('#progressBarBootstrap').css('width', percentBootstrap + '%');
                    $('#progressBarQuery').css('width', percentQuery + '%');
                    $('#progressBarTotal').css('width', percentTotal + '%');

                    updateStatusBadge('#badgeBootstrapStatus', stats.avg_bootstrap, 100, 200);
                    updateStatusBadge('#badgeQueryStatus', stats.avg_query, 30, 80);
                    updateStatusBadge('#badgeTotalStatus', stats.avg_total, 150, 350);

                    const dates = data.chart_data.map(item => item.date);
                    const totals = data.chart_data.map(item => item.total);
                    const queries = data.chart_data.map(item => item.query);
                    const bootstraps = data.chart_data.map(item => item.bootstrap);

                    initChart(dates, totals, queries, bootstraps);

                    const indexHealth = data.index_health;
                    const $indexBody = $('#indexHealthBody');
                    $indexBody.empty();

                    if (indexHealth.length === 0) {
                        $indexBody.append('<tr><td colspan="4" class="text-center py-3 text-muted">Semua tabel indeks normal.</td></tr>');
                    } else {
                        indexHealth.forEach(health => {
                            const badge = health.indexed ?
                                '<span class="badge bg-success-subtle text-success rounded-pill px-2">Terindeks</span>' :
                                '<span class="badge bg-warning-subtle text-warning rounded-pill px-2">Missing Index</span>';

                            const sqlButton = health.indexed ?
                                '<span class="text-muted small">Optimal</span>' :
                                `<div class="d-flex align-items-center gap-2">
                                     <code class="text-monospace text-wrap bg-light border p-1 rounded" style="font-size: 0.75rem;">${health.action}</code>
                                     <button class="btn btn-sm btn-outline-secondary copy-btn px-2 py-1 shadow-sm" type="button" data-clipboard-text="${health.action}" title="Salin SQL">
                                         <i class="bi bi-clipboard"></i>
                                     </button>
                                 </div>`;

                            $indexBody.append(`
                                <tr>
                                    <td><strong>${health.table}</strong></td>
                                    <td><code>${health.column}</code></td>
                                    <td>${badge}</td>
                                    <td>${sqlButton}</td>
                                </tr>
                            `);
                        });
                    }

                    const phpConfig = data.php_config;
                    $('#cfgOpcache').text(phpConfig.opcache_enabled)
                        .removeClass().addClass(`badge bg-${phpConfig.opcache_status}-subtle text-${phpConfig.opcache_status} rounded-pill px-3 py-1 fw-bold`);
                    $('#cfgEnv').text(phpConfig.env_mode === 'development' ? 'Development' : 'Production')
                        .removeClass().addClass(`badge bg-${phpConfig.env_status}-subtle text-${phpConfig.env_status} rounded-pill px-3 py-1 fw-bold`);
                    $('#cfgToolbar').text(phpConfig.debug_toolbar)
                        .removeClass().addClass(`badge bg-${phpConfig.debug_status}-subtle text-${phpConfig.debug_status} rounded-pill px-3 py-1 fw-bold`);

                    const slowestUris = data.slowest_uris;
                    const $slowBody = $('#slowUrisTableBody');
                    const perfTable = document.getElementById('performanceTable');

                    if (perfTable) {
                        perfTable.classList.remove('native-table-init');
                    }
                    $slowBody.empty();

                    if (slowestUris.length === 0) {
                        $slowBody.append('<tr><td colspan="6" class="text-center py-3 text-muted">Belum ada data log performa yang terekam.</td></tr>');
                    } else {
                        slowestUris.forEach(row => {
                            // Hitung status warna
                            let totalStatus = 'success';
                            if (row.avg_total > 3000) totalStatus = 'danger';
                            else if (row.avg_total > 1500) totalStatus = 'warning';

                            let bsStatus = 'success';
                            if (row.avg_bootstrap > 500) bsStatus = 'danger';
                            else if (row.avg_bootstrap > 250) bsStatus = 'warning';

                            let qStatus = 'success';
                            if (row.avg_query > 1000) qStatus = 'danger';
                            else if (row.avg_query > 500) qStatus = 'warning';

                            // Rekomendasi
                            let recommendation = '<span class="text-success fw-medium"><i class="bi bi-check-circle-fill me-1"></i> Performa Optimal</span>';
                            if (totalStatus === 'danger') {
                                if (bsStatus === 'danger') {
                                    recommendation = '<span class="text-danger fw-medium">Bootstrap bottleneck terdeteksi. Inisialisasi framework lambat. Pastikan PHP OPcache aktif di server produksi dan ubah <code>CI_ENVIRONMENT</code> ke <code>production</code>.</span>';
                                } else if (qStatus === 'danger') {
                                    recommendation = '<span class="text-danger fw-medium">Database query bottleneck. Periksa indeks tabel, gunakan <i>Eager Loading</i>, atau aktifkan <i>Query Caching</i>.</span>';
                                } else {
                                    recommendation = '<span class="text-danger fw-medium">Waktu eksekusi PHP lambat. Analisis *loop* panjang atau operasi *I/O* (File/Network) yang menahan *thread*.</span>';
                                }
                            }

                            const methodBadgeColor = row.method === 'GET' ? 'dark' : (row.method === 'POST' ? 'primary' : 'secondary');

                            $slowBody.append(`
                                <tr>
                                    <td>
                                        <div class="d-flex align-items-center">
                                            <span class="badge bg-light text-${methodBadgeColor} border me-2" style="width: 50px;">${row.method}</span>
                                            <span class="text-pink font-monospace small">${row.uri}</span>
                                        </div>
                                    </td>
                                    <td class="text-center text-${totalStatus} fw-bold" data-sort="${row.avg_total}">${row.avg_total} ms</td>
                                    <td class="text-center text-${bsStatus}" data-sort="${row.avg_bootstrap}">${row.avg_bootstrap} ms</td>
                                    <td class="text-center text-${qStatus}" data-sort="${row.avg_query}">${row.avg_query} ms</td>
                                    <td class="text-center text-muted" data-sort="${row.hits}">${row.hits} hits</td>
                                    <td class="small">${recommendation}</td>
                                </tr>
                            `);
                        });
                    }

                    // Initialize with the native table utils to get the exact "bawaan" layout and sorting icons
                    initTableUtils();
                }
            },
            error: function () {
                console.error('Gagal mengambil data monitoring performa.');
            }
        });
    }

    function updateStatusBadge(selector, value, goodBound, warningBound) {
        let status = 'Optimal';
        let bgClass = 'bg-success-subtle text-success';
        if (value > warningBound) {
            status = 'Lambat';
            bgClass = 'bg-danger-subtle text-danger';
        } else if (value > goodBound) {
            status = 'Cukup';
            bgClass = 'bg-warning-subtle text-warning';
        }
        $(selector).text(status).removeClass().addClass('badge rounded-pill ' + bgClass);
    }

    let debounceTimer = null;
    function debounce(func, delay) {
        return function () {
            const context = this;
            const args = arguments;
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => func.apply(context, args), delay);
        };
    }

    function runBenchmark() {
        const table = $('#benchmarkTable').val();
        const keyword = $('#benchmarkKeyword').val();
        const csrfTokenName = $('meta[name="X-CSRF-TOKEN-NAME"]').attr('content') || 'csrf_test_name';
        const csrfHash = $('meta[name="X-CSRF-TOKEN"]').attr('content') || '';

        $('#benchmarkResults').addClass('d-none');
        $('#benchmarkDetailsSection').addClass('d-none');
        $('#benchmarkLoading').removeClass('d-none');
        $('#btnRunBenchmark').prop('disabled', true);

        $.ajax({
            url: urlBenchmark,
            type: 'POST',
            data: {
                [csrfTokenName]: csrfHash,
                table: table,
                keyword: keyword
            },
            dataType: 'json',
            success: function (res) {
                if (res.csrf_token && $('meta[name="X-CSRF-TOKEN"]').length) {
                    $('meta[name="X-CSRF-TOKEN"]').attr('content', res.csrf_token);
                }

                $('#benchmarkLoading').addClass('d-none');
                $('#btnRunBenchmark').prop('disabled', false);

                if (res.status === 'success') {
                    const data = res.data;

                    $('#resBootstrap').text(data.bootstrap_time.toFixed(1) + ' ms');
                    $('#resQuery').text(data.query_time.toFixed(1) + ' ms');

                    updateColorHighlight('#resBootstrap', data.bootstrap_time, 100, 200);
                    updateColorHighlight('#resQuery', data.query_time, 30, 80);

                    $('#resTotal').text(data.total_time.toFixed(1) + ' ms');
                    updateColorHighlight('#resTotal', data.total_time, 150, 350);

                    const totalTime = data.total_time;
                    let ratingLabel = '';
                    let ratingBadge = '';
                    let ratingClass = '';
                    let ratingIcon = '';
                    let containerBorder = '';

                    if (totalTime <= 100) {
                        ratingLabel = 'Sangat Cepat / Optimal (Excellent)';
                        ratingBadge = 'OPTIMAL';
                        ratingClass = 'bg-success text-white';
                        containerBorder = 'border-success-subtle bg-success bg-opacity-10';
                        ratingIcon = 'bi-speedometer2 text-success';
                    } else if (totalTime <= 300) {
                        ratingLabel = 'Performa Baik (Good)';
                        ratingBadge = 'BAIK';
                        ratingClass = 'bg-info text-white';
                        containerBorder = 'border-info-subtle bg-info bg-opacity-10';
                        ratingIcon = 'bi-check-circle-fill text-info';
                    } else if (totalTime <= 800) {
                        ratingLabel = 'Cukup / Butuh Optimasi (Fair)';
                        ratingBadge = 'BUTUH OPTIMASI';
                        ratingClass = 'bg-warning text-dark';
                        containerBorder = 'border-warning-subtle bg-warning bg-opacity-10';
                        ratingIcon = 'bi-exclamation-triangle-fill text-warning';
                    } else {
                        ratingLabel = 'Sangat Lambat / Kritis (Slow)';
                        ratingBadge = 'KRITIS';
                        ratingClass = 'bg-danger text-white';
                        containerBorder = 'border-danger-subtle bg-danger bg-opacity-10';
                        ratingIcon = 'bi-exclamation-octagon-fill text-danger';
                    }

                    $('#overallRatingContainer').removeClass()
                        .addClass('p-3 rounded-3 mb-3 border d-flex align-items-center justify-content-between ' + containerBorder);
                    $('#overallRatingIcon').html(`<i class="bi ${ratingIcon}"></i>`);
                    $('#overallRatingLabel').text(ratingLabel);
                    $('#overallRatingBadge').removeClass().addClass('badge rounded-pill px-3 py-2 fw-bold ' + ratingClass).text(ratingBadge);

                    $('#resCount').text(data.results_count.toLocaleString('id-ID'));
                    $('#resMemory').text(data.memory_usage.toFixed(1) + ' MB');
                    $('#resSqlCount').text(data.query_count);

                    const $sqlBody = $('#benchmarkSqlTableBody');
                    $sqlBody.empty();

                    if (data.queries.length === 0) {
                        $sqlBody.append('<tr><td colspan="5" class="text-center py-3 text-muted">Tidak ada kueri SQL SELECT yang dieksekusi. Mungkin query ter-cache.</td></tr>');
                    } else {
                        data.queries.forEach(q => {
                            const exp = q.explain;
                            const scanType = exp.type || 'N/A';
                            const rowsScanned = exp.rows ? exp.rows.toLocaleString('id-ID') : 'N/A';
                            const keyUsed = exp.key || '<span class="text-danger fw-bold">NULL (No Index)</span>';

                            let scanBadge = 'bg-secondary';
                            if (scanType === 'ALL') scanBadge = 'bg-danger';
                            else if (scanType === 'index') scanBadge = 'bg-warning text-dark';
                            else if (scanType === 'ref' || scanType === 'const') scanBadge = 'bg-success';

                            $sqlBody.append(`
                                <tr>
                                    <td>
                                        <pre class="bg-light p-2 rounded-2 text-monospace text-wrap mb-0" style="font-size: 0.8rem;">${q.sql}</pre>
                                    </td>
                                    <td class="text-center fw-medium">${q.time.toFixed(1)}</td>
                                    <td class="text-center">${keyUsed}</td>
                                    <td class="text-center">${rowsScanned}</td>
                                    <td class="text-center"><span class="badge ${scanBadge} rounded-pill">${scanType}</span></td>
                                </tr>
                            `);
                        });
                    }

                    const $recList = $('#recommendationList');
                    $recList.empty();

                    data.recommendations.forEach(rec => {
                        let icon = 'bi-check-circle-fill text-success';
                        let borderClass = 'border-success-subtle bg-success-subtle bg-opacity-25';
                        if (rec.level === 'danger') {
                            icon = 'bi-exclamation-triangle-fill text-danger';
                            borderClass = 'border-danger-subtle bg-danger-subtle bg-opacity-25';
                        } else if (rec.level === 'warning') {
                            icon = 'bi-exclamation-circle-fill text-warning';
                            borderClass = 'border-warning-subtle bg-warning-subtle bg-opacity-25';
                        }

                        $recList.append(`
                            <div class="p-3 border ${borderClass} rounded-3 d-flex gap-3 align-items-start">
                                <div class="fs-4"><i class="bi ${icon}"></i></div>
                                <div>
                                    <h6 class="fw-bold mb-1">${rec.title}</h6>
                                    <p class="text-muted small mb-0">${rec.desc}</p>
                                </div>
                            </div>
                        `);
                    });

                    $('#benchmarkResults').removeClass('d-none');
                    $('#benchmarkDetailsSection').removeClass('d-none');
                } else {
                    Swal.fire('Gagal', res.message, 'error');
                }
            },
            error: function () {
                $('#benchmarkLoading').addClass('d-none');
                $('#btnRunBenchmark').prop('disabled', false);
                Swal.fire('Error', 'Gagal menjalankan profiling performa.', 'error');
            }
        });
    }

    $('#benchmarkForm').on('submit', function (e) {
        e.preventDefault();
        runBenchmark();
    });

    $('#benchmarkTable').on('change', function () {
        runBenchmark();
    });

    $('#benchmarkKeyword').on('input', debounce(function () {
        runBenchmark();
    }, 500));

    function updateColorHighlight(selector, value, goodBound, warningBound) {
        $(selector).removeClass('text-success text-warning text-danger text-info text-primary');
        if (value > warningBound) {
            $(selector).addClass('text-danger');
        } else if (value > goodBound) {
            $(selector).addClass('text-warning');
        } else {
            $(selector).addClass('text-success');
        }
    }

    $(document).on('click', '.copy-btn', function () {
        const text = $(this).attr('data-clipboard-text');
        navigator.clipboard.writeText(text).then(() => {
            const $btn = $(this);
            $btn.html('<i class="bi bi-check-lg text-success"></i>');
            setTimeout(() => {
                $btn.html('<i class="bi bi-clipboard"></i>');
            }, 1500);
        });
    });

    $('#btnRefreshStats').on('click', function () {
        const $btn = $(this);
        $btn.prop('disabled', true).find('i').addClass('spin');
        loadPerformanceData();
        setTimeout(() => {
            $btn.prop('disabled', false).find('i').removeClass('spin');
        }, 1000);
    });

    $('#btnClearStats').on('click', function () {
        Swal.fire({
            title: 'Apakah Anda yakin?',
            text: "Semua data log performa di tabel database akan dihapus!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ea5455',
            cancelButtonColor: '#82868b',
            confirmButtonText: 'Ya, Hapus!',
            cancelButtonText: 'Batal',
            customClass: {
                confirmButton: 'btn btn-danger me-2',
                cancelButton: 'btn btn-secondary'
            },
            buttonsStyling: false
        }).then((result) => {
            if (result.isConfirmed) {
                const csrfTokenName = $('meta[name="X-CSRF-TOKEN-NAME"]').attr('content') || 'csrf_test_name';
                const csrfHash = $('meta[name="X-CSRF-TOKEN"]').attr('content') || '';

                $.ajax({
                    url: urlClear,
                    type: 'POST',
                    data: {
                        [csrfTokenName]: csrfHash
                    },
                    dataType: 'json',
                    success: function (res) {
                        if (res.csrf_token && $('meta[name="X-CSRF-TOKEN"]').length) {
                            $('meta[name="X-CSRF-TOKEN"]').attr('content', res.csrf_token);
                        }
                        if (res.status === 'success') {
                            loadPerformanceData();
                            Swal.fire({
                                title: 'Berhasil!',
                                text: res.message,
                                icon: 'success',
                                confirmButtonColor: '#7367f0'
                            });
                        } else {
                            Swal.fire({
                                title: 'Gagal!',
                                text: res.message || 'Gagal menghapus log.',
                                icon: 'error',
                                confirmButtonColor: '#7367f0'
                            });
                        }
                    },
                    error: function () {
                        Swal.fire({
                            title: 'Error!',
                            text: 'Terjadi kesalahan saat menghapus log performa.',
                            icon: 'error',
                            confirmButtonColor: '#7367f0'
                        });
                    }
                });
            }
        });
    });

    // Initial triggers
    loadPerformanceData();
    runBenchmark();
}
